import jsPDF from "jspdf";
import "jspdf-autotable";
import NarcoticsQualitativeQuestions from "./NarcoticsQualitativeQuestions";

import AuditSXLogo from "../../../assets/AuditSX-logo.png";

function findUserName(userNames, id) {
  const user = userNames.find((user) => user.user_id === id);
  return user ? user.userName : null;
}

export const narcoticsPDFReport = (narcoticsRecords, userNames) => {
  const doc = new jsPDF();

  const headingText = "AuditSX:\nNarcoticsAudit Report Summary";

  const addHeader = (doc, currentY) => {
    doc.addImage(AuditSXLogo, "PNG", 15, currentY, 54, 15);

    doc.setFontSize(13);
    doc.text(headingText, 120, currentY + 6);

    return currentY + 25;
  };

  let currentY = 20; // Initial Y position for the first record

  // Add the header for the first page
  currentY = addHeader(doc, currentY);

  doc.setFontSize(10);

  narcoticsRecords.forEach((record, index) => {
    if (index > 0) {
      doc.addPage();
      currentY = 20;

      // Add the header for each new page
      currentY = addHeader(doc, currentY);
    }

    doc.setFontSize(10);
    doc.text(`Record #${index + 1}`, 13, currentY);

    currentY += 5;

    // Adding Record Header
    doc.autoTable({
      startY: currentY,
      head: [["Field", "Value"]],
      body: [
        ["Facility", record.facility],
        ["Unit", record.unit],
        ["Facility Designate Name", record.facilityDesignateName],
        ["Pharmacy Designate Name", record.pharmacyDesignateName],
        ["Created By", findUserName(userNames, record.createdBy)],
      ],
    });

    currentY = doc.lastAutoTable.finalY + 10;

    doc.setFontSize(12);
    doc.text("Quantitative Data:", 13, currentY);
    currentY += 5;

    // doc.autoTable({
    //   startY: currentY,
    //   head: [["Quantitative Overview", ""]],
    //   body: [
    //     ["Total Records", record.quantitativeCompliance.totalRecords],
    //     ["Passed Records", record.quantitativeCompliance.passedRecords],
    //     [
    //       "Failed Records",
    //       record.quantitativeCompliance.totalRecords -
    //         record.quantitativeCompliance.passedRecords,
    //     ],
    //   ],
    // });
    // currentY = doc.lastAutoTable.finalY + 5;

    // Adding Quantitative Data Table
    doc.autoTable({
      startY: currentY,
      head: [
        [
          "Unit",
          "Outcome",
          "Quantity1",
          "Quantity2",
          "Quantity3",
          "Medication",
          "Resident Name",
          "Prescription No",
        ],
      ],
      body: record.quantitativeRecords.map((qr) => [
        qr.unit,
        qr.outcome ? "true" : "false",
        qr.quantity1,
        qr.quantity2,
        qr.quantity3,
        qr.medication,
        qr.residentName,
        qr.prescriptionNo,
      ]),
    });

    currentY = doc.lastAutoTable.finalY + 10;

    doc.setFontSize(12);
    doc.text("Qualitative Data:", 13, currentY);
    currentY += 5;

    // Adding Qualitative Data Table with questions from NarcoticsQualitativeQuestions array
    const qualitativeData = Object.entries(record.qualitative)
      .filter(([key]) => key.startsWith("q"))
      .map(([question, data]) => [
        NarcoticsQualitativeQuestions[parseInt(question.slice(1)) - 1],
        data.answer,
        data.comment,
      ]);
    doc.autoTable({
      startY: currentY,
      head: [["Question", "Answer", "Comment"]],
      body: qualitativeData,
    });

    currentY = doc.lastAutoTable.finalY + 10;

    // compliance outcome
    // doc.autoTable({
    //   startY: currentY,
    //   head: [["Compliance", "Result"]],
    //   body: [
    //     [
    //       "Outcome",
    //       record.qualitative.compliance.outcome === true ? "Passed" : "Failed",
    //     ],
    //     ["Percentage", record.qualitative.compliance.percentage * 100],
    //   ],
    // });
    // currentY = doc.lastAutoTable.finalY + 10;

    doc.line(0, currentY, 287, currentY);

    currentY += 10;
  });

  doc.save(`narcotics_report_${new Date().toISOString()}.pdf`);
};
